module.exports = "/images/DiagramGray.jpg";